import Vue from 'vue'
import App from './App.vue'

// 引入vue-router --------------------
import VueRouter from 'vue-router'
import router from './router/index.js'
// 解决重复点击路由报错问题开始**********即：错误不在提示
// 把这段代码直接粘贴到router/index.js中的Vue.use(VueRouter)之前
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
	// return originalPush.call(this, location).catch(err => {
	// 	// err
	// 	console.log(err)
	// })
	return originalPush.call(this, location).catch(() => {})
};
// 解决重复点击路由报错问题结束**********即：错误不在提示
Vue.use(VueRouter)
// ----------------------------------

// 引入
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


//Swiper3
require('swiper/dist/css/swiper.css')
// import
import VueAwesomeSwiper from 'vue-awesome-swiper'
// mount with global
Vue.use(VueAwesomeSwiper)

// 引入图片懒加载
// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload)

// 引入瀑布流插件
import waterfall from "vue-waterfall2";
Vue.use(waterfall);


// 引入v-viewer，图片放大预览
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
	Options: {
		'inline': true,
		'button': true,
		'navbar': false, //缩略图导航
		'title': false, // 是否显示当前图片的标题
		'toolbar': true,
		'tooltip': true,
		'movable': true,
		'zoomable': true,
		'rotatable': true,
		'scalable': true,
		'transition': true,
		'fullscreen': true,
		'keyboard': true,
		'maxZoomRatio': 100, //数字	100	最大缩放比例
		'url': 'data-source'
	}
})

Vue.config.productionTip = false

new Vue({
	render: h => h(App),
	// 引入vue-router --
	router: router,
	// -----------------
}).$mount('#app')
